import React, {useCallback, useState, useEffect} from "react"
import {useSelector, useDispatch} from "react-redux"
import alertify from "alertifyjs"

// import Select from "./Select"
import {setHourglassState} from "../../redux/actions/hourglassAction"

import "./rightpanel.scss"
import {useDecode} from "../../hooks/useDecode"

const RightPanel = () => {
  const dispatch = useDispatch()
  const product2d = useSelector(state => state.product2d)
  const makFabric = useSelector(state => state.makFabric)
  const product2dCanvasState = useSelector(state => state.product2dCanvasState)
  // const products2d = useSelector(state => state.products2d)
  // const [activeSel, setActiveSel] = useState("")

  const [cartState, setCartState] = useState(false)
  const [contState, setContState] = useState(null)
  const [price, setPrice] = useState(0)

  const currency = useDecode(
    product2d && product2d.currency ? product2d.currency : "",
  )

  useEffect(() => {
    if (product2d && makFabric) {
      makFabric.help.addToCartDisabled = setContState
    }
  }, [makFabric, product2d])

  useEffect(() => {
    if (contState) {
      const url =
        window.location !== window.parent.location
          ? document.referrer
          : document.location.origin

      let data = {action: "APP_CHANGES"}

      let arr = contState.map(item => [...item.payload]).flat()
      if (arr.length) {
        setCartState(true)
        window.parent.postMessage(JSON.stringify({...data, type: true}), url)
      } else {
        setCartState(false)
        window.parent.postMessage(JSON.stringify({...data, type: false}), url)
      }
    }
  }, [contState])

  useEffect(() => {
    if (product2d) {
      if (contState) {
        console.log()
        let f = contState.filter(i => i.payload.length)

        if (f.length && product2d.partPrice) {
          setPrice(
            (
              parseFloat(product2d.price) +
              (f.length - 1) * parseFloat(product2d.partPrice)
            ).toFixed(2),
          )
        } else {
          setPrice(parseFloat(product2d.price).toFixed(2))
        }
      } else {
        setPrice(parseFloat(product2d.price).toFixed(2))
      }
    }
  }, [contState, product2d])

  const addToCart = useCallback(
    e => {
      e.preventDefault()
      dispatch(setHourglassState(true))

      const url =
        window.location !== window.parent.location
          ? document.referrer
          : document.location.origin

      let cp = contState.filter(i => i.payload.length)

      makFabric.addToCart(
        product2dCanvasState,
        e => {
          console.log(e.final)
          let data = {
            action: "addToCartAction",
            content: e.metadata,
            screenshot: e.final.side.map(i => ({
              name: i.name,
              img: i.screenShot,
            })),
            // name: product2d.name,
            price: price,
            size: product2d.size,
            sku: product2d.variationSKU,
            garmetId: product2d.id,
            customizebleParts: cp && cp.length ? parseInt(cp.length) : 0,
          }
          // console.groupCollapsed("Add to Cart data")
          // console.log(data)
          // console.groupEnd()

          if (!e.metadata) {
            alertify.error("Can't save the data")
          } else {
            window.parent.postMessage(JSON.stringify(data), url)
          }

          dispatch(setHourglassState(false))
        },
        {sku: product2d.sku},
      )
    },
    [
      contState,
      dispatch,
      makFabric,
      price,
      product2d.id,
      product2d.size,
      product2d.variationSKU,
      product2dCanvasState,
    ],
  )

  // const toggleSelect = useCallback(e => {
  //   setActiveSel(prev =>
  //     prev !== e.target.dataset.name ? e.target.dataset.name : "",
  //   )
  // }, [])

  // const selectModel = useCallback(e => console.log(e.target), [])

  // const createProdOptions = useMemo(
  //   () => products2d.map(item => ({label: item.label, name: item.name})),
  //   [products2d],
  // )

  // const createSizeOptions = useMemo(() => {
  //   const f = products2d.find(item => item.name === product2d.name)
  //   if (f) return f.sizes.map(item => ({name: item.label, label: item.label}))
  // }, [product2d, products2d])

  return (
    <div className="rightPanelContainer">
      {/* 
      <div className="rightPanelContent">
       <Select
          label={product2d.label}
          name={"PROD"}
          handleToggle={toggleSelect}
          handleSelect={selectModel}
          active={activeSel === "PROD"}
          options={createProdOptions}
        />
      </div>
      <div className="rightPanelContent">
        <Select
          label={product2d.size}
          name={"SIZE"}
          handleToggle={toggleSelect}
          handleSelect={selectModel}
          active={activeSel === "SIZE"}
          options={createSizeOptions}
        />
      </div>*/}
      <div className={"rightPanelContent " + "rightPanelContent_price"}>
        <span>Price</span>
        <span>{`${currency}${price}`}</span>
      </div>
      <div className="rightPanelContent">
        <button
          className="rightPanelAddToCart"
          onClick={addToCart}
          disabled={!cartState}
        >
          Add To Cart
        </button>
      </div>
    </div>
  )
}

export default RightPanel
